const WATCH_CATEGORIES = [
    'Wristwatch',
    'Dive',
    'Dress',
    'Pilot/Aviation',
    'Field',
    'Chronograph',
    'GMT/World Timer',
    'Racing',
    'Tool',
    'Pocket Watch',
    'Accessory',
    'Other',
];
const WATCH_BRANDS = [
    'Audemars Piguet',
    'Breitling',
    'Cartier',
    'Casio',
    'Citizen',
    'Grand Seiko',
    'Hamilton',
    'IWC',
    'Jaeger-LeCoultre',
    'Longines',
    'Nomos',
    'Omega',
    'Oris',
    'Orient',
    'Panerai',
    'Patek Philippe',
    'Rolex',
    'Seiko',
    'TAG Heuer',
    'Tissot',
    'Tudor',
    'Other',
];
const WATCH_CATEGORY_BRANDS = {
    Dive: ['Rolex', 'Omega', 'Tudor', 'Seiko', 'Citizen', 'Oris', 'Panerai', 'Other'],
    Dress: ['Patek Philippe', 'Jaeger-LeCoultre', 'Cartier', 'Longines', 'Nomos', 'Grand Seiko', 'Other'],
    'Pilot/Aviation': ['IWC', 'Breitling', 'Hamilton', 'Longines', 'Citizen', 'Other'],
    Chronograph: ['Omega', 'Rolex', 'TAG Heuer', 'Breitling', 'Seiko', 'Other'],
    'GMT/World Timer': ['Rolex', 'Omega', 'Tudor', 'Grand Seiko', 'Other'],
    Racing: ['TAG Heuer', 'Omega', 'Rolex', 'Tudor', 'Other'],
};
const WATCH_BRAND_MODELS = {
    Rolex: ['Submariner', 'Daytona', 'GMT-Master', 'Datejust', 'Explorer', 'Sea-Dweller', 'Air-King', 'Oyster Perpetual'],
    Omega: ['Speedmaster', 'Seamaster', 'Constellation', 'De Ville', 'Railmaster'],
    Tudor: ['Black Bay', 'Pelagos', 'Ranger', 'Prince'],
    Seiko: ['SKX007', 'SKX009', 'Turtle', 'Presage', 'Alpinist', '62MAS'],
    'Grand Seiko': ['Snowflake', 'SBGA211', 'SBGW231'],
    'Patek Philippe': ['Nautilus', 'Aquanaut', 'Calatrava'],
    IWC: ['Pilot Mark', 'Big Pilot', 'Portugieser'],
    'TAG Heuer': ['Carrera', 'Monaco', 'Autavia', 'Aquaracer'],
    Breitling: ['Navitimer', 'Chronomat', 'Superocean'],
    Hamilton: ['Khaki Field', 'Khaki Aviation', 'Jazzmaster', 'Ventura'],
    Casio: ['G-Shock DW-5600', 'G-Shock GA-2100', 'Oceanus', 'Pro Trek'],
};
const WATCH_SUBCATEGORIES = {
    Dive: ['Professional', 'Recreational', 'Compressor'],
    Dress: ['Ultra-Thin', 'Classic', 'Moonphase'],
    Chronograph: ['Manual Wind', 'Automatic', 'Flyback'],
    'Pocket Watch': ['Open Face', 'Hunter Case', 'Railroad Grade'],
    Accessory: ['Strap', 'Bracelet', 'Watch Box', 'Watch Winder', 'Tool Set', 'Spring Bar'],
};
export const watchesVaultType = {
    id: 'watches',
    label: 'Watches',
    tagline: 'Track your timepiece collection',
    icon: 'Watch',
    platformLabel: 'Brand',
    categories: WATCH_CATEGORIES,
    brands: WATCH_BRANDS,
    brandModels: WATCH_BRAND_MODELS,
    categoryBrands: WATCH_CATEGORY_BRANDS,
    subcategories: WATCH_SUBCATEGORIES,
    conditions: ['mint', 'excellent', 'good', 'fair', 'poor', 'parts'],
    specializedFields: [
        { key: 'movement_type', label: 'Movement', type: 'select', options: ['Automatic', 'Manual Wind', 'Quartz', 'Solar', 'Spring Drive', 'Kinetic'] },
        { key: 'case_material', label: 'Case Material', type: 'text', placeholder: 'e.g. Stainless Steel' },
        { key: 'case_diameter', label: 'Case Diameter', type: 'text', placeholder: 'e.g. 40mm' },
        { key: 'water_resistance', label: 'Water Resistance', type: 'text', placeholder: 'e.g. 200m' },
        { key: 'crystal_type', label: 'Crystal', type: 'select', options: ['Sapphire', 'Mineral', 'Acrylic/Hesalite', 'Hardlex'] },
        { key: 'complications', label: 'Complications', type: 'text', placeholder: 'e.g. Date, Chronograph, GMT' },
        { key: 'caliber', label: 'Caliber/Movement', type: 'text', placeholder: 'e.g. Cal. 3135' },
        { key: 'serial_number', label: 'Serial Number', type: 'text', placeholder: 'Serial number' },
        { key: 'lug_width', label: 'Lug Width', type: 'text', placeholder: 'e.g. 20mm' },
    ],
    specializedFeatures: {
        service_history: true,
        insurance_tracking: true,
        strap_inventory: true,
    },
    aiSystemPrompt: `You are an expert in watches and horology. Analyze the provided image and identify the watch. Provide details including: the manufacturer/brand, model name, reference number if visible, approximate year of manufacture, category (Dive, Dress, Chronograph, etc.), movement type (automatic, manual, quartz), case material, condition assessment, and any notable features like complications, bezel type, or limited editions. If you can identify the caliber, bracelet type, or dial details, mention those.`,
    maintenanceAlertTypes: [
        'movement_service',
        'water_resistance_test',
        'crystal_replacement',
        'gasket_replacement',
        'custom',
    ],
    fileTypes: ['manual_pdf', 'other'],
    defaultThemes: ['guilloche', 'midnight_dial', 'patina', 'rose_gold', 'lume'],
};
//# sourceMappingURL=watches.js.map